import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = ({ flexDirection }) => () => ({
  root: {
    display: 'flex',
    flexDirection,
    position: 'relative',
  },
  loading: {
    display: 'none',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
  },
  isVisible: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
});

export const LoadingOverlay = ({
  className, children, isVisible, flexDirection,
}) => {
  const classes = useDefaultStyles(getStyles({ flexDirection }));
  const rootClassName = classnames(classes.root, 'loading-overlay', className);
  const overlayClassName = classnames(classes.loading, isVisible ? classes.isVisible : '', 'loading-overlay__overlay');
  return (
    <div className={rootClassName}>
      <div className={overlayClassName} />
      {children}
    </div>
  );
};

LoadingOverlay.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  isVisible: PropTypes.bool,
  flexDirection: PropTypes.oneOf(['row', 'column']),
};

LoadingOverlay.defaultProps = {
  className: undefined,
  children: null,
  isVisible: false,
  flexDirection: 'row',
};
